export default __webpack_public_path__ + "static/media/empty-creo-translation.faee3f48.svg";